// src/api/PublicSiteConfiguration.js
import api from "./axios";

export const getPublicSiteConfiguration = () => api.get("/api/public/site-configuration/");